import { useTranslation } from 'hooks/useTranslation';
import styles from './ItineraryTimeline.module.scss';

export type ItineraryTimelineType = {
  title: string;
  steps: string[];
};

type Props = {
  itineraryWithSteps: ItineraryTimelineType[];
};

const ItineraryTimeline = ({
  itineraryWithSteps,
}: Props): JSX.Element | null => {
  const { t } = useTranslation();

  return (
    <>
      {itineraryWithSteps.map((items, index) => {
        const title = items.title.split(/\[(.*?)\]/);
        const days = title[1];
        const description = title[2].replace(/[^a-zA-Z0-9 ]/g, '').trim();

        return (
          <div className="timeline pl-12 pb-4" key={index}>
            <p className="timeline-dot font-bold mb-3">
              {`${t('itinerary.day')} ${days || ''}, ${description || ''}`}
            </p>
            <div className="pl-6">
              {items.steps.map((step, idx) => {
                return (
                  <ul className={styles.unorderedList} key={idx}>
                    <li>
                      <p className="pb-6 last:pb-0 whitespace-pre-line leading-8 md:leading-normal">
                        {step}
                      </p>
                    </li>
                  </ul>
                );
              })}
            </div>
          </div>
        );
      })}
    </>
  );
};

export default ItineraryTimeline;
